import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Industries() {
  return (
    <OrderedModuleEditor
      resource="admin/site/industries"
      singular="industry"
      title="Industries"
      subtitle="Drag to reorder industry sectors shown on the site."
      titleKey="name"
      defaultValues={{ order: 1, name: "" }}
      getItemLabel={(it, idx) => it.name || `Industry ${idx + 1}`}
      renderPreviewItem={(it) => (
        <div className="flex justify-center py-3">
          <span className="inline-flex items-center justify-center px-4 py-2 rounded-full glass text-sm font-medium text-white">
            {it.name || "Untitled"}
          </span>
        </div>
      )}
      renderInspector={(item, patch) => (
        <div className="space-y-1">
          <Label className="text-xs text-white/50">Industry Name</Label>
          <Input value={item.name || ""} onChange={(e) => patch({ name: e.target.value })} className="bg-black/20 border-white/10 text-white" />
        </div>
      )}
    />
  );
}
